import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import DropDownInputField from "../../forms/DropDownInputField";
import {fromJS, Map} from "immutable";
import {validateIncludes} from "../../../lib/Validators";
import {cancelSetAvailability, setAvailability} from "../../../actions/ShippingApiActions";
import {getSubmitInfoForCommand} from "../../../reducers/shippingReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

const availabilityOptions = fromJS([
  { id: "available", title: "Available" },
  { id: "unavailable", title: "Unavailable" },
  { id: "bulk", title: "Bulk" },
  { id: "enquire", title: "Enquire" }
]);

function validateForm(values) {
  let errors = Map();
  errors = validateIncludes(errors, values, "availability", availabilityOptions.map(x => x.get("id")));
  return errors.toJS();
}

class SetAvailabilityForm extends Component {

  render() {
    let {handleSubmit, submit, submitInfo} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Availability"
              name="availability"
              component={DropDownInputField}
              data={availabilityOptions}
              valueKey="id"  
              titleKey="title" 
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelSetAvailability} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "SetAvailabilityForm",
  validate: validateForm
})(SetAvailabilityForm);

const ConnectedForm = connect(
  (state, ownProps) => ({
    submitInfo: getSubmitInfoForCommand(state.get("shipping"), "SetAvailability"),
    initialValues: {
      kind: ownProps.data.get("kind"),
      code: ownProps.data.get("code"),
      availability: ownProps.data.get("availability")
    }
  }),
  {
    cancelSetAvailability,
    submit,
    onSubmit: (data) => setAvailability(data)
  }
)(ReduxForm);

export default ConnectedForm;